module.exports = __webpack_public_path__ + "img/icon_17.3b81ab22.gif";